import { useMediaQuery } from "@mui/material"
import AccountWeb from "./AccountWeb"
import AccountMob from "./AccountMob"
export default function Equity() {
    const isSmallScreen = useMediaQuery("(max-width:800px)");
    return isSmallScreen ? <AccountMob /> : <AccountWeb />;

}